<template>
	<EventBundleLayout :event="event">
		<Empty v-if="bundles.length === 0"/>
		<CardGrid v-else tight>
			<Card v-for="bundle in bundles" :key="`bundles-${bundle.id}`" :title="bundle.title" :subtitle="transChoice('events.bundles.offers_count', bundle.offers_count)">
				<template #badges>
					<Badge v-if="bundle.active" :color="Color.Green" active>{{ trans('general.enabled') }}</Badge>
					<Badge v-else :color="Color.Red">{{ trans('general.disabled') }}</Badge>
					<Badge class="cursor-pointer" @click.stop="copyTextToClipboard(bundle.id)">#{{ bundle.id }}</Badge>
				</template>
				<template #footer>
					<Link :as="SecondaryButton" :color="Color.Blue" :href="route('events.bundles.edit', [event.id, bundle.id])">
						<i class="fa-solid fa-edit mr-2"/>
						{{ trans('general.edit') }}
					</Link>
					<SoftButton :color="Color.Red" @click.stop="remove(bundle)">
						<i class="fa-solid fa-trash mr-2"/>
						{{ trans('general.delete') }}
					</SoftButton>
				</template>
			</Card>
		</CardGrid>
	</EventBundleLayout>
</template>
<script setup lang="ts">
import axios from 'axios'
import {route} from 'ziggy-js'
import {Link} from '@inertiajs/vue3'
import {Color} from '@/Types/Enums/Color'
import Empty from '@/Components/UI/Empty.vue'
import {defineProps, ref, type Ref} from 'vue'
import {type Event} from '@/Types/Events/Event'
import Card from '@/Components/UI/Cards/Card.vue'
import {trans, transChoice} from 'laravel-vue-i18n'
import Badge from '@/Components/UI/Badges/Badge.vue'
import {type Bundle} from '@/Types/Events/Bundles/Bundle'
import CardGrid from '@/Components/UI/Cards/CardGrid.vue'
import SoftButton from '@/Components/UI/Buttons/SoftButton.vue'
import EventBundleLayout from '@/Layouts/EventBundleLayout.vue'
import SecondaryButton from '@/Components/UI/Buttons/SecondaryButton.vue'
import {copyTextToClipboard, showInfo, showSuccess, showValidationErrors} from '@/Helpers/general'

const props = defineProps<{
	event:Event,
	bundles:Array<Bundle>,
}>()

const event:Ref<Event> = ref(props.event)
const working:Ref<boolean> = ref(false)
const bundles:Ref<Array<Bundle>> = ref(props.bundles)

function remove(bundle:Bundle):void{
	if(!working.value && confirm(trans('general.confirm_action'))){
		working.value = true
		showInfo(trans('general.deleting'))
		axios.delete(route('events.bundles.destroy', [event.value.id, bundle.id])).then(() => {
			showSuccess(trans('general.deleted'))
			const index = bundles.value.findIndex((b:Bundle) => b.id === bundle.id)
			if(index > -1){
				bundles.value.splice(index, 1)
			}
		}).catch(showValidationErrors).finally(() => {
			working.value = false
		})
	}
}
</script>